import { TRADINGACCTYPES__MUTATIONS } from "../mutation-types";
import { TRADINGACCTYPES__ACTIONS } from '../action-types'
import { TRADINGACCTYPES__API } from '@/_helpers/urls'
import http from "@/_helpers/http";

// State
const state = {
    accounttypes: []
};

// Mutations
const mutations = {
    [TRADINGACCTYPES__MUTATIONS.TRADINGACCTYPES](state, data) {
        state.accounttypes = data?.data
    },
};

const getters = {};

// Actions
const actions = {
    async [TRADINGACCTYPES__ACTIONS.TRADINGACCTYPES]({ commit }) {
        try {
            const { data } = await http().get(TRADINGACCTYPES__API.TRADINGACCTYPES);
            commit(TRADINGACCTYPES__MUTATIONS.TRADINGACCTYPES, data);
        } catch (error) {
            console.error("Error trades account types:", error);
        }
    },
};

export default {
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
